/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Conversion d'un lead externe en simulation, affectée à un courtier. Payload commun aux routes materialiser/cbno et materialiser/gli (la route impose la branche).
 * 
 * @export
 * @interface MaterialiserLeadCbnoCommand
 */
export interface MaterialiserLeadCbnoCommand {
    /**
     * 
     * @type {string}
     * @memberof MaterialiserLeadCbnoCommand
     */
    leadId: string;
    /**
     * Courtier destinataire — doit appartenir à la plateforme traitante
     * @type {string}
     * @memberof MaterialiserLeadCbnoCommand
     */
    brokerId: string;
}

/**
 * Check if a given object implements the MaterialiserLeadCbnoCommand interface.
 */
export function instanceOfMaterialiserLeadCbnoCommand(value: object): value is MaterialiserLeadCbnoCommand {
    if (!('leadId' in value) || value['leadId'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    return true;
}

export function MaterialiserLeadCbnoCommandFromJSON(json: any): MaterialiserLeadCbnoCommand {
    return MaterialiserLeadCbnoCommandFromJSONTyped(json, false);
}

export function MaterialiserLeadCbnoCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialiserLeadCbnoCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'leadId': json['leadId'],
        'brokerId': json['brokerId'],
    };
}

export function MaterialiserLeadCbnoCommandToJSON(json: any): MaterialiserLeadCbnoCommand {
    return MaterialiserLeadCbnoCommandToJSONTyped(json, false);
}

export function MaterialiserLeadCbnoCommandToJSONTyped(value?: MaterialiserLeadCbnoCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leadId': value['leadId'],
        'brokerId': value['brokerId'],
    };
}

